<c3-config-section-box
  [title]="TP_SECTIONS_INFO['app-features'].label"
  [icon]="TP_SECTIONS_INFO['app-features'].icon"
>
  <div config-description>
    <p>{{ TP_SECTIONS_INFO["app-features"].description }}</p>
    <div class="c3-flex ion-align-items-center">
      <ion-icon
        size="small"
        color="tertiary"
        [src]="'information-outline' | getIcon"
        class="ion-margin-end"
      >
      </ion-icon>
      <span>
        <strong>Nota:</strong> l'attivazione <strong>non comporta l'obbligo</strong> da parte del
        paziente ad inserire periodicamente i dati scelti.
      </span>
    </div>
  </div>

  <div [c3ConfigForm]="this">
    <!-- actions -->
    <ion-toolbar>
      <ion-buttons slot="end">
        <!-- select all -->
        <ion-button (click)="onSelectAll()" color="secondary" fill="solid">
          <ion-icon slot="start" [src]="'checkbox-multiple-marked-outline' | getIcon"> </ion-icon>
          <span class="ion-hide-md-down">Seleziona tutto</span>
        </ion-button>

        <!-- deselect all -->
        <ion-button (click)="onDeselectAll()" color="secondary" fill="solid">
          <ion-icon slot="start" [src]="'checkbox-multiple-blank-outline' | getIcon"> </ion-icon>
          <span class="ion-hide-md-down">Deseleziona tutto</span>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>

    <!-- app features -->
    <div *ngFor="let context of filteredContexts$ | async | keyvalue">
      <h3>{{ context.value[0]?.contextLabel }}</h3>
      <ion-grid>
        <ion-row>
          <ion-col
            size="12"
            size-md="6"
            size-lg="4"
            *ngFor="let feature of context.value"
            class="ion-no-padding"
          >
            <ion-item lines="none">
              <ion-checkbox
                slot="start"
                color="secondary"
                [checked]="selection[feature._id]"
                [value]="feature._id"
                (ionChange)="onSelectionChange($event)"
              >
              </ion-checkbox>
              <ion-avatar class="app-img">
                <ion-img [src]="feature._id | cdImage: '.'" alt="Icona"></ion-img>
              </ion-avatar>
              <ion-label>{{ feature.it }}</ion-label>
            </ion-item>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </div>
</c3-config-section-box>
